import React from "react";
import { useTranslation } from "utilities/i18n";
import { useQueryParamString, Link } from "polyrouter";
import { Layout } from "views/Main/Layouts";
import { Card } from "collections/Cards";
import { LoadingIndicator, PolyLogoFooter } from "elements";
import lensLogo from "assets/images/poly_logo_lens.svg";
import { hasBackgroundImage } from "utilities/misc";
import { useUnsubscribeMutation } from "generated/graphql";

export const UnsubscribeNotifications: React.FC = () => {
  const { t } = useTranslation();
  const [unsubscribeResult, unsubscribe] = useUnsubscribeMutation();
  const { fetching, error, data } = unsubscribeResult;
  const backgroundStyle = hasBackgroundImage("home", "light");
  const [emailId] = useQueryParamString<string>("id");
  const unsubscribeUser = async () => {
    await unsubscribe({ id: emailId || "" });
  };
  const { Content } = Layout;

  return (
    <div className="main theme-light" style={backgroundStyle}>
      <Layout>
        <Content className="about pr-0">
          <div className="brand pb-1 text-center">
            <img
              src={lensLogo}
              alt="Poly Lens"
              data-testid="logo"
              className="confirm-logo"
            />
          </div>
          <Card className="notification-card text-center">
            <h4 className="text-center title pb-5">{t("UNSUBSCRIBE")}</h4>
            <div>
              {fetching ? (
                <LoadingIndicator
                  className="theme-independent"
                  title={t("UNSUBSCRIBE_FETCHING")}
                />
              ) : (
                <>
                  {!data && !error ? (
                    <div>
                      <div className="notification-card-text">
                        {t("UNSUBSCRIBE_DESC")}
                      </div>
                      <button
                        className="btn btn-primary"
                        onClick={unsubscribeUser}
                      >
                        {t("UNSUBSCRIBE")}
                      </button>
                    </div>
                  ) : (
                    <>
                      <div className="notification-card-text">
                        {data
                          ? t("UNSUBSCRIBE_SUCCESS")
                          : t("UNSUBSCRIBE_ERROR")}
                      </div>
                      <Link to="/home" className="btn btn-primary mt-1">
                        {t("HOME")}
                      </Link>
                    </>
                  )}
                </>
              )}
            </div>
          </Card>
        </Content>
        <PolyLogoFooter />
      </Layout>
    </div>
  );
};
